import { render, staticRenderFns } from "./videoConfigure.vue?vue&type=template&id=455369f2&scoped=true&"
import script from "./videoConfigure.vue?vue&type=script&lang=js&"
export * from "./videoConfigure.vue?vue&type=script&lang=js&"
import style0 from "./videoConfigure.vue?vue&type=style&index=0&id=455369f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455369f2",
  null
  
)

export default component.exports